import React from 'react';

/**
 * Vertical rhythm wrapper for landing page sections.
 * Renders an optional eyebrow, gradient title, and subtitle.
 */
export default function Section({
  id,
  eyebrow,
  title,
  subtitle,
  children,
  className = '',
  align = 'center',
}) {
  const alignClass = align === 'center' ? 'text-center' : 'text-left';

  return (
    <section id={id} className={`max-w-6xl mx-auto px-4 py-16 ${className}`}>
      {(eyebrow || title || subtitle) && (
        <div className={`${alignClass} mb-12 max-w-3xl ${align === 'center' ? 'mx-auto' : ''}`}>
          {eyebrow && (
            <p className="text-sm font-semibold uppercase tracking-wide text-accent-primary mb-3">
              {eyebrow}
            </p>
          )}
          {title && (
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="gradient-text">{title}</span>
            </h2>
          )}
          {subtitle && (
            <p className="text-lg text-text-secondary">{subtitle}</p>
          )}
        </div>
      )}
      {children}
    </section>
  );
}
